

























import UUIFComponents from '@/shared/uuifComponent';
import { Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { MswAppTitle } from '@/shared/msw-app-title';
import  Renewaltable  from './renewaltable.component.vue';

const cssPrefix = 'snb-renewalmanager';

@Component({
  components: {
    ...UUIFComponents,
    SwTabGroup,
    SwTabPage,
    MswAppTitle,
    Renewaltable,
  },
})

export default class Renewalmanager extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  selectedTabId: string = 'pending';
  basicTabsProps: TabProps[] = [
    {
      tabId: 'pending',
      label: this.$t('renewalManager.opportunity')
      .toString(),
    },
    {
      tabId: 'booked',
      label: this.$t('renewalManager.booked')
      .toString(),
    },
    {
      tabId: 'cancelled',
      label: this.$t('renewalManager.cancelled')
      .toString(),
    },
  ];
  onSelectTab(tabId: string) {
    console.warn(tabId);
    if (tabId !== this.selectedTabId) {
      this.selectedTabId = tabId;
      this.setQuoteDetails();
    }
  }

  setQuoteDetails() {
    const req = {
      status : this.selectedTabId,
      equoteId : '',
      equoteStatus : '',
      country : '',
      state : '',
      customerName : '',
      amountFrom : '',
      amountTo : '',
      expiryDateFrom : '',
      expiryDateTo : '',
      quoteOwnership : '',
      partial : '',
      serialNumber : '',
    };
    this.$store.dispatch('RenewalManagerStoreModule/fetchquoteList', req)
    .then((res:any) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('RenewalManagerStoreModule/setQuoteList', res.partnerRespList);
      }
    });
  }

  created() {
    this.setHelpContentId({ helpId: ['renewal-manager'] });
  }

  mounted() {
    this.setQuoteDetails();
  }
}
